import React, {useMemo, useEffect} from 'react'
import moment from 'moment'
import * as htmlToImage from 'html-to-image'
import ReactPaginate from 'react-paginate'
import {Button, Box, Text, Flex, Checkbox, Grid, GridItem} from '@chakra-ui/react'
import {useParams, useLocation, useSearchParams} from 'react-router-dom'
import {MdArrowBackIos} from 'react-icons/md'

import {MdUpdate} from 'react-icons/md'

import * as leaguesAPI from '../../api/leagues'
import PlayersList1 from './components/PlayersList1'
import PlayersList2 from './components/PlayersList2'
import PlayersList3 from './components/PlayersList3'
import PlayersList4 from './components/PlayersList4'
import PlayersList5 from './components/PlayersList5'
import PlayersList6 from './components/PlayersList6'
import PlayersList7 from './components/PlayersList7'
import PlayersList8 from './components/PlayersList8'
import PlayersList9 from './components/PlayersList9'
import PlayersList10 from './components/PlayersList10'
import PlayersList11 from './components/PlayersList11'
import PlayersList12 from './components/PlayersList12'
import PlayersList13 from './components/PlayersList13'
import PlayersList14 from './components/PlayersList14'
import PlayersList15 from './components/PlayersList15'
import PlayersListv5 from './components/PlayersListv5'

import config from '../../constants/config'
import {getBase64, useTranslation, formatDateTime} from '../../constants/helpers'
import Loading from '../Loading'
const ExportMatchDetail = () => {
  let {leagueId, seasonId, teamId} = useParams()
  const {t} = useTranslation()
  const [searchParams] = useSearchParams()
  const lang = window.sessionStorage.getItem('lang')
  // const {isOpen, onOpen, onClose} = useDisclosure()
  const [playerType, setPlayerType] = React.useState(null)
  const [state, setState] = React.useState({
    downloading: false,
    loading: true,
    loadingTeam: true,
    loadingSeason: true,
    loadingSponsor: true,
    players: [],
    dataSponsor: [],
    dataTeam: {},
    dataSeason: {},
    page: 0,
    total: 0,
    index: 0,
    content: '',
    league: {},
    checkboxStaff: true,
    checkboxPlayer: true,
    showBirthDate: true,
    showSponsor: true,
    checkboxLeagueName: true,
    checkboxSeasonName: true,
    numberPlayer: 21 // so luong hien thi trong 1 page giao dien dau tien
  })

  const [show, setShow] = React.useState(false)
  const [selected, setSelected] = React.useState(0)
  const [ready, setReady] = React.useState(false)
  const nodeplayer1 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer2 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer3 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer4 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer5 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer6 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer7 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer8 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer9 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer10 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer11 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer12 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer13 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer14 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayer15 = React.useRef(new Date().toISOString() + 'player')
  const nodeplayerV5 = React.useRef(new Date().toISOString() + 'player')

  const select = value => () => {
    setSelected(value)
    setShow(true)
  }
  const fetchData = React.useCallback(() => {
    leaguesAPI
      .getTeamsBySeasonId(leagueId, seasonId, teamId)
      .then(r => {
        const listTemp = r?.members?.reduce(
          (p, c) => {
            if (!p[c.types]) p[c.types] = []
            if (c.types.length > 1) {
              p['football_player_type'].push(c)
              p['football_staff_type'].push(c)
              return p
            }
            p[c.types].push(c)
            return p
          },
          {football_player_type: [], football_staff_type: []}
        )
        const listPlayer = [...listTemp.football_staff_type, ...listTemp.football_player_type]

        setState(s => ({...s, dataTeam: r, players: listPlayer, total: r.members?.length, loadingTeam: false}))
        if (r.members.filter(i => i.types.includes('football_staff_type')).length > 1) {
          setState(s => ({...s, numberPlayer: 24}))
        }
      })
      .catch(e => {
        setState(s => ({...s, loadingTeam: false}))
      })
    leaguesAPI
      .getLeagueById(leagueId)
      .then(r => {
        setState(s => ({...s, league: r, dataSeason: r.seasons.filter(i => i.id === seasonId)[0], loadingSeason: false}))
      })
      .catch(e => {
        setState(s => ({...s, loadingSeason: false}))
      })
    leaguesAPI
      .getSponsor(leagueId, seasonId)
      .then(r => {
        const dataTemp = r.reduce((p, n) => {
          if (n.sponsors.length) {
            p = [...p, ...n.sponsors]
          }
          return p
        }, [])
        setState(s => ({...s, dataSponsor: dataTemp, loadingSponsor: false}))
      })
      .catch(e => {
        setState(s => ({...s, loadingSponsor: false}))
      })
  }, [leagueId, seasonId, teamId])

  const setShows = () => {
    setShow(false)
    setReady(false)
  }

  React.useEffect(() => {
    fetchData()
  }, [fetchData])
  React.useEffect(() => {
    switch (selected) {
      case 1:
        setPlayerType(nodeplayer1.current)
        break
      case 2:
        setPlayerType(nodeplayer2.current)
        break
      case 3:
        setPlayerType(nodeplayer3.current)
        break
      case 4:
        setPlayerType(nodeplayer4.current)
        break
      case 5:
        setPlayerType(nodeplayer5.current)
        break
      case 6:
        setPlayerType(nodeplayer6.current)
        break
      case 7:
        setPlayerType(nodeplayer7.current)
        break
      case 8:
        setPlayerType(nodeplayer8.current)
        break
      case 9:
        setPlayerType(nodeplayer9.current)
        break
      case 10:
        setPlayerType(nodeplayer10.current)
        break
      case 11:
        setPlayerType(nodeplayer11.current)
        break
      case 12:
        setPlayerType(nodeplayer12.current)
        break
      case 13:
        setPlayerType(nodeplayer13.current)
        break
      case 14:
        setPlayerType(nodeplayer14.current)
        break
      case 15:
        setPlayerType(nodeplayer15.current)
        break
      case 51:
        setPlayerType(nodeplayerV5.current)
        break
      default:
        break
    }
  }, [selected])

  // const footballPlayerType = state.checkboxPlayer ? state?.players.filter(i => i.types.includes('football_player_type')) : []
  // const footballStaffTypes = state.checkboxStaff ? state?.players.filter(i => i.types.includes('football_staff_type')) : []
  const players1 = [...new Map(state?.players?.slice(state.page * state.numberPlayer, state.page * state.numberPlayer + state.numberPlayer).map(c => [c['id'], c])).values()] //fix duplicate player and staff
  const handlePageClick = ({selected}) => {
    setState(s => ({...s, page: selected}))
  }
  // const onChangeText = e => {
  //   e.persist()
  //   setState(s => ({...s, content: e.target.value}))
  // }
  const handleChangeCheckbox = ({target}) => {
    setState(s => ({...s, [target.name]: target.checked}))
  }
  const css = {
    cursor: 'pointer',
    border: '2px solid #fff',
    borderRadius: '2px'
  }
  /////////////
  ///////////
  /////////
  ///////
  const exportImage = async () => {
    if (state.downloading) return
    setState(s => ({...s, downloading: true}))
    const timeStamp = moment().format('yyyyMMDDHHmmss')
    const text = {
      vi: 'DanhSachThanhVien',
      en: 'RosterList'
    }
    htmlToImage
      .toJpeg(document.getElementById(playerType), {pixelRatio: 3, quality: 1})
      .then(dataUrl => {
        var link = document.createElement('a')
        link.download = `${text[lang]}_${state?.dataTeam?.name}_${timeStamp}.jpeg`
        link.href = dataUrl
        link.click()
        setState(s => ({...s, downloading: false}))
      })
      .catch(function (error) {
        setState(s => ({...s, downloading: false}))
        console.error('oops, something went wrong!', error)
      })
  }
  useEffect(() => {
    // Send `message` to the parent using the postMessage method on the window.parent reference.
    window.parent.postMessage('ExportPlayers', '*')
  }, [])

  const setAgain = () => {
    setState(s => ({...s, checkboxPlayer: true, checkboxStaff: true}))
  }
  if (state.loadingSeason || state.loadingTeam || state.loadingSponsor) {
    return (
      <Box height={'50vh'} display="flex" flexDirection={'column'} alignItems={'center'} justifyContent="center">
        <Text>Loading . . . !</Text>
      </Box>
    )
  }
  const thumbnail = {
    type1: {
      en: '/chooseImgXuatAnhUs.jpg',
      vi: '/chooseImgXuatAnh.jpg'
    },
    type2: {
      en: '/template_2us.jpeg',
      vi: '/template_2.jpeg'
    },
    type3: {
      en: '/template_3us.jpeg',
      vi: '/template_3.png'
    },
    typev5: {
      en: '/dsmauv5.jpg',
      vi: '/dsmauv5.jpg'
    },
    type4: {
      // en: '/cu18chooseus.jpeg',
      // vi: '/cu18choose.jpeg'
      en: '/mau4en.jpeg',
      vi: '/mau4vi.jpeg'
    },
    type5: {
      // en: '/cu18chooseus.jpeg',
      // vi: '/cu18choose.jpeg'
      en: '/mau_5_en.jpg',
      vi: '/mau_5_vi.jpg'
    },
    type6: {
      // en: '/cu18chooseus.jpeg',
      // vi: '/cu18choose.jpeg'
      en: '/mau6en.jpg',
      vi: '/mau6vi.jpg'
    },
    type7: {
      // en: '/cu18chooseus.jpeg',
      // vi: '/cu18choose.jpeg'
      en: '/ds_mau7_vi.jpg',
      vi: '/ds_mau7_vi.jpg'
    },
    type8: {
      // en: '/cu18chooseus.jpeg',
      // vi: '/cu18choose.jpeg'
      en: '/ds_mau8_vi.jpg',
      vi: '/ds_mau8_vi.jpg'
    },
    type9: {
      en: '/playersListDarkNeon.png',
      vi: '/playersListDarkNeon.png'
    },
    type10: {
      en: '/playersListMidnightGold.png',
      vi: '/playersListMidnightGold.png'
    },
    type11: {
      en: '/playersListOceanBlue.png',
      vi: '/playersListOceanBlue.png'
    },
    type12: {
      en: '/playersListElectricPurple.png',
      vi: '/playersListElectricPurple.png'
    },
    type13: {
      en: '/playersListEmeraldGreen.png',
      vi: '/playersListEmeraldGreen.png'
    },
    type14: {
      en: '/playersListCrimsonRed.png',
      vi: '/playersListCrimsonRed.png'
    },
    type15: {
      en: '/playersListRoyalBlue.png',
      vi: '/playersListRoyalBlue.png'
    }
  }
  if (!show) {
    return (
      <Box height={'100%'} display="flex" flexDirection={'column'} justifyContent="space-between">
        <Grid templateColumns="repeat(5, 1fr)" gap={6}>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} style={css} className="pointer" height={'100%'} onClick={select(1)}>
              <img style={{height: '420px', margin: '0 auto'}} src={thumbnail['type1'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} style={css} className="pointer" height={'100%'} onClick={select(2)}>
              <img style={{height: '420px', margin: '0 auto'}} src={thumbnail['type2'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} style={css} className="pointer" height={'100%'} onClick={select(3)}>
              <img style={{height: '420px', margin: '0 auto'}} src={thumbnail['type3'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(51)}>
              <img style={{margin: '0 auto'}} src={thumbnail['typev5'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(4)}>
              <img style={{margin: '0 auto'}} src={thumbnail['type4'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(5)}>
              <img style={{margin: '0 auto'}} src={thumbnail['type5'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(6)}>
              <img style={{margin: '0 auto'}} src={thumbnail['type6'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(7)}>
              <img style={{margin: '0 auto'}} src={thumbnail['type7'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(8)}>
              <img style={{margin: '0 auto'}} src={thumbnail['type8'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(9)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type9'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(10)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type10'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(11)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type11'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(12)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type12'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(13)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type13'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(14)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type14'][lang]} />
            </Box>
          </GridItem>
          <GridItem w="100%">
            <Box _hover={{borderColor: '#11368f !important'}} backgroundColor={'#eeeeee'} height="100%" alignItems={'center'} display="flex" flexDirection={'column'} justifyContent="center" style={css} className="pointer" width={'100%'} onClick={select(15)}>
              <img style={{height: '420px', width: '100%', objectFit: 'cover', margin: '0 auto'}} src={thumbnail['type15'][lang]} />
            </Box>
          </GridItem>
        </Grid>
      </Box>
    )
  } else {
    return (
      <Box maxWidth={1480} margin="0 auto" display="flex" flexDirection={'column'} justifyContent="center">
        <Flex display={'flex'} marginBottom="10px" flexDirection="row" justifyContent={'space-between'}>
          <Box display={'flex'} flexDirection={'row'} mb={3} onClick={() => setShows()} cursor="pointer">
            <MdArrowBackIos size={'28px'} />
            <Text>{t('back')}</Text>
          </Box>
          <Flex display="flex" flexDirection={'row'} justifyContent="flex-end">
            <Checkbox textTransform={'capitalize'} mr={2} name={'checkboxStaff'} colorScheme="red" isChecked={state.checkboxStaff} onChange={handleChangeCheckbox}>
              {t('staff')}
            </Checkbox>
            <Checkbox textTransform={'capitalize'} mr={2} name={'checkboxPlayer'} colorScheme="green" isChecked={state.checkboxPlayer} onChange={handleChangeCheckbox}>
              {t('player')}
            </Checkbox>
            <Checkbox textTransform={'capitalize'} mr={2} name={'showBirthDate'} colorScheme="green" isChecked={state.showBirthDate} onChange={handleChangeCheckbox}>
              {t('birthday')}
            </Checkbox>
            {state.dataSponsor.length > 0 && (
              <Checkbox textTransform={'capitalize'} mr={2} name={'showSponsor'} colorScheme="green" isChecked={state.showSponsor} onChange={handleChangeCheckbox}>
                {t('sponsor')}
              </Checkbox>
            )}
            {selected === 1 && (
              <Checkbox textTransform={'capitalize'} mr={2} name={'checkboxLeagueName'} colorScheme="green" isChecked={state.checkboxLeagueName} onChange={handleChangeCheckbox}>
                {t('league_name')}
              </Checkbox>
            )}
            {selected === 1 && (
              <Checkbox textTransform={'capitalize'} mr={2} name={'checkboxSeasonName'} colorScheme="green" isChecked={state.checkboxSeasonName} onChange={handleChangeCheckbox}>
                {t('season_name')}
              </Checkbox>
            )}
            <Button textTransform={'capitalize'} ml={4} isLoading={state.downloading} isDisabled={!ready} colorScheme="blue" onClick={exportImage}>
              {t('download')}
            </Button>
          </Flex>
        </Flex>
        <Flex display={'flex'} flexDirection="row" justifyContent={'center'}>
          <Box>
            {selected === 1 && (
              <Box>
                <>
                  <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList1
                      isShowSponsor={state.showSponsor}
                      sponsorData={state.dataSponsor}
                      setIsReady={setReady}
                      id={nodeplayer1.current}
                      isShowBirthDay={state.showBirthDate}
                      players={players1}
                      size={2480}
                      setCheckBox={setAgain}
                      page={state.page}
                      checkboxPlayer={state.checkboxPlayer}
                      checkboxStaff={state.checkboxStaff}
                      seasonData={state.dataSeason}
                      teamData={state.dataTeam}
                      league={state.league}
                      checkboxLeagueName={state.checkboxLeagueName}
                      checkboxSeasonName={state.checkboxSeasonName}
                    />
                  </div>
                  <PlayersList1
                    isShowSponsor={state.showSponsor}
                    sponsorData={state.dataSponsor}
                    setCheckBox={setAgain}
                    size={480}
                    page={state.page}
                    isShowBirthDay={state.showBirthDate}
                    players={players1}
                    seasonData={state.dataSeason}
                    teamData={state.dataTeam}
                    checkboxPlayer={state.checkboxPlayer}
                    checkboxStaff={state.checkboxStaff}
                    league={state.league}
                    checkboxLeagueName={state.checkboxLeagueName}
                    checkboxSeasonName={state.checkboxSeasonName}
                  />
                </>
                <ReactPaginate initialPage={state.page} previousLabel={'<'} nextLabel={'>'} breakLabel={'...'} breakClassName={'break-me'} pageCount={Math.ceil(state.total / state.numberPlayer)} marginPagesDisplayed={2} pageRangeDisplayed={1} onPageChange={handlePageClick} containerClassName={'pagination'} subContainerClassName={'pages pagination'} activeClassName={'active'} />
              </Box>
            )}
          </Box>
          {selected === 2 && (
            <>
              {/* <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList2 id={nodeplayer1.current} players={players1} size={2480} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
                  </div> */}
              <Flex width="1100" id={nodeplayer2.current} height="100%" backgroundImage="url(/BG_DSPLAYER.png)" justifyContent="center" padding="20px">
                <PlayersList2 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 3 && (
            <>
              {/* <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList2 id={nodeplayer1.current} players={players1} size={2480} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
                  </div> */}
              <Flex id={nodeplayer3.current} height="100%" backgroundImage="url(/BG_DSPLAYER.png)" justifyContent="center" padding="20px">
                <PlayersList3 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 4 && (
            <>
              {/* <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList2 id={nodeplayer1.current} players={players1} size={2480} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
                  </div> */}
              <Flex id={nodeplayer4.current} width={1240} minHeight={778} backgroundImage="url(/BG-01.jpg)" justifyContent="center" padding="20px" backgroundSize={'cover'} backgroundPosition={'center'}>
                <PlayersList4 size={1240} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 5 && (
            <>
              {/* <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList2 id={nodeplayer1.current} players={players1} size={2480} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
                  </div> */}
              <Flex id={nodeplayer5.current} width={1240} minHeight={778} backgroundImage="url(/Mau-5.jpg)" justifyContent="center" padding="20px" backgroundSize={'cover'} backgroundPosition={'center'}>
                <PlayersList5 size={1240} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 6 && (
            <>
              {/* <div style={{overflow: 'scroll', width: 0, height: 0}}>
                    <PlayersList2 id={nodeplayer1.current} players={players1} size={2480} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
                  </div> */}
              <Flex id={nodeplayer6.current} width={1240} minHeight={778} backgroundImage="url(/mau6bg.jpg)" justifyContent="center" padding="20px" backgroundSize={'cover'} backgroundPosition={'center'}>
                <PlayersList6 size={1240} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 7 && (
            <>
              <Flex id={nodeplayer7.current} height="100%" backgroundImage="url(/BG_DSPLAYER.png)" justifyContent="center" padding="20px">
                <PlayersList7 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 8 && (
            <>
              <Flex width="1100" id={nodeplayer2.current} height="100%" backgroundImage="url(/BG_DSPLAYER.png)" justifyContent="center" padding="20px">
                <PlayersList8 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
          {selected === 9 && (
            <>
              <div id={nodeplayer9.current}>
                <PlayersList9 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 10 && (
            <>
              <div id={nodeplayer10.current}>
                <PlayersList10 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 11 && (
            <>
              <div id={nodeplayer11.current}>
                <PlayersList11 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 12 && (
            <>
              <div id={nodeplayer12.current}>
                <PlayersList12 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 13 && (
            <>
              <div id={nodeplayer13.current}>
                <PlayersList13 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 14 && (
            <>
              <div id={nodeplayer14.current}>
                <PlayersList14 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 15 && (
            <>
              <div id={nodeplayer15.current}>
                <PlayersList15 size={1080} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </div>
            </>
          )}
          {selected === 51 && (
            <>
              <Flex id={nodeplayerV5.current} width={1240} minHeight={778} backgroundImage="url(/bgv5.jpg)" justifyContent="center" padding="20px" backgroundSize={'cover'} backgroundPosition={'center'}>
                <PlayersListv5 size={1240} setIsReady={setReady} isShowSponsor={state.showSponsor} isShowBirthDay={state.showBirthDate} checkboxPlayer={state.checkboxPlayer} checkboxStaff={state.checkboxStaff} sponsorData={state.dataSponsor} players={state.dataTeam.members} seasonData={state.dataSeason} teamData={state.dataTeam} league={state.league} />
              </Flex>
            </>
          )}
        </Flex>
      </Box>
    )
  }
}

function areEqual(p, n) {
  return true
}

export default React.memo(ExportMatchDetail, areEqual)
